import { Outlet } from 'react-router-dom';
import { useConfig } from '@/hooks/useConfig';
import ShillTicker from '@/components/degen/ShillTicker';

export default function PublicLayout() {
    const { config } = useConfig();
    const showTicker = config.features?.ticker ?? true;

    return (
        <div className="min-h-screen relative overflow-hidden" style={{ background: '#0A0A0B' }}>
            {/* Ticker bar - conditionally shown */}
            {showTicker && (
                <div className="fixed top-0 left-0 right-0 z-50">
                    <ShillTicker />
                </div>
            )}

            {/* Main content */}
            <main className={showTicker ? 'pt-12' : ''}>
                <Outlet />
            </main>
        </div>
    );
}
